<div class="session-expired-dialog">
  <h2 mat-dialog-title>Session Expired</h2>
  <div mat-dialog-content>
    <p class="session-expired-message">{{ message }}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button class="sign-in-btn" (click)="onSignIn()">
      Sign In
    </button>
  </div>
</div>
